const DEFAULT_HOME_CONTENT = {
  hero_badge: "Verified doctors · live queues",
  hero_title: "Find a doctor.",
  hero_highlight: "Skip the waiting room.",
  hero_body: "Browse verified specialists, see fees and clinic timings, and book a walk-in token from home. Watch the queue move live and arrive only when it's your turn.",
  primary_button_label: "Find a doctor",
  doctor_button_label: "I'm a doctor",
  specialties_eyebrow: "Specialties",
  specialties_title: "Find care by specialty",
  specialties_link_label: "Browse all doctors",
  featured_eyebrow: "Featured doctors",
  featured_title: "Popular this week",
  featured_link_label: "Browse all",
  stats_one_value: "50+",
  stats_one_label: "CLINICS ACTIVE",
  stats_two_value: "10k+",
  stats_two_label: "TOKENS ISSUED",
  stats_three_value: "30m",
  stats_three_label: "AVG. WAIT REDUCTION",
  stats_four_value: "98%",
  stats_four_label: "USER SATISFACTION",
  green_strip_enabled: true,
};

export default DEFAULT_HOME_CONTENT;
